import { NAME } from './constants';

export const HIDE_ALERT = `${NAME}/HIDE_ALERT`;
export const SHOW_ALERT = `${NAME}/SHOW_ALERT`;
